var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "gg-card",
    [
      _c(
        "v-card-text",
        {
          staticClass: "pt-0 text-left"
        },
        [
          _c(
            "v-col",
            {
              staticClass: "pl-0",
              attrs: {
                cols: "24",
                md: "12"
              }
            },
            [
              _c(
                "v-alert",
                {
                  attrs: {
                    type: "error",
                    icon: "mdi-alert"
                  }
                },
                [
                  _vm._v(
                    " Your service(s) will be scheduled for cancellation. Please back up any important data before proceeding. If you have other services or domains you would like to cancel, you must submit a separate request. "
                  )
                ]
              )
            ],
            1
          ),
          _c("h2", [_vm._v("Services to be Cancelled:")]),
          _c(
            "v-list",
            [
              _vm.cancellation_type === "full"
                ? _c(
                    "v-list-item",
                    [
                      _c("v-list-item-content", [
                        _vm._v(
                          _vm._s(
                            _vm.decodeHtmlCharCodes(
                              this.selected_cr_service.name
                            )
                          )
                        )
                      ])
                    ],
                    1
                  )
                : _vm._e(),
              _vm._l(_vm.servicesForCancellation, function(service) {
                return _c(
                  "v-list-item",
                  {
                    key: "service-".concat(service.id)
                  },
                  [
                    _c("v-list-item-content", [
                      _vm._v(
                        " " +
                          _vm._s(_vm.decodeHtmlCharCodes(service.name)) +
                          " " +
                          _vm._s(
                            service.domain ? "- ".concat(service.domain) : ""
                          ) +
                          " "
                      )
                    ])
                  ],
                  1
                )
              })
            ],
            2
          ),
          _c(
            "h2",
            {
              staticClass: "pt-3"
            },
            [_vm._v("Comments")]
          ),
          _vm.comment.question
            ? _c("p", [_vm._v(_vm._s(_vm.comment.question))])
            : _c("p", [
                _vm._v(
                  "Please leave a few words to help us validate and expedite your request."
                )
              ]),
          _c(
            "v-col",
            {
              staticClass: "pl-0 pb-0",
              attrs: {
                cols: "12",
                md: "6"
              }
            },
            [
              _c(
                "v-form",
                {
                  on: {
                    submit: function submit($event) {
                      $event.preventDefault()
                      return _vm.proceed($event)
                    }
                  }
                },
                [
                  _c("gg-input-label", [
                    _vm._v("Comments "),
                    _vm.commentRequired
                      ? _c("span", [_vm._v("(Required)")])
                      : _vm._e()
                  ]),
                  _c("v-textarea", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: {
                          required: _vm.commentRequired
                        },
                        expression: "{ required: commentRequired }"
                      }
                    ],
                    staticClass: "gg-input",
                    attrs: {
                      outlined: "",
                      dense: "",
                      rows: "3",
                      name: "Comments",
                      "error-messages": _vm.errors.collect("Comments")
                    },
                    model: {
                      value: _vm.comments,
                      callback: function callback($$v) {
                        _vm.comments = $$v
                      },
                      expression: "comments"
                    }
                  }),
                  _c("v-checkbox", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "truthy",
                        expression: "'truthy'"
                      }
                    ],
                    attrs: {
                      color: "primary",
                      label: _vm.confirmationLabel,
                      name: "Agreement",
                      "error-messages": _vm.errors.collect("Agreement")
                    },
                    model: {
                      value: _vm.agreement,
                      callback: function callback($$v) {
                        _vm.agreement = $$v
                      },
                      expression: "agreement"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-card-actions",
        {
          staticClass: "pl-3"
        },
        [
          _c(
            "gg-btn",
            {
              attrs: {
                secondary: "",
                loading: _vm.crCancelLoading
              },
              on: {
                click: _vm.cancelCR
              }
            },
            [_vm._v(" Cancel Request ")]
          ),
          _c(
            "gg-btn",
            {
              attrs: {
                loading: _vm.loading,
                disabled: _vm.submitDisabled
              },
              on: {
                click: _vm.proceed
              }
            },
            [_vm._v("Submit Request")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }